import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { openModal } from 'state/actions'

import { NavLink } from 'react-router-dom'

import { Draggable, Droppable } from 'react-beautiful-dnd'
import { doSort } from 'utils'

import { filter, each } from 'lodash'

import { isMobile } from 'utils'

import isEqual from 'react-fast-compare'

class FolderContents extends Component {
	state = {
		hasMounted: !!(this.props.compact && this.props.isFirst)
	}

	shouldComponentUpdate = (nextProps, nextState) => {
		if (this.props.currentlyDraggedElement !== nextProps.currentlyDraggedElement) {
			const { currentlyDraggedElement } = nextProps

			if (currentlyDraggedElement) {
				let isInFolder = false

				if (nextProps.folderObject.folders.includes(currentlyDraggedElement)) {
					isInFolder = true
				}

				if (nextProps.folderObject.projects.includes(currentlyDraggedElement)) {
					isInFolder = true
				}

				if (!isInFolder) {
					return false
				}
			}
		}

		if(this.state.hasMounted !== nextState.hasMounted){
			return true
		}

		if (!this.props.isLast && !nextProps.isLast) {
			return false
		}

		const arePropsEqual = isEqual(this.props, nextProps)
		const isStateEqual = isEqual(this.state, nextState)

		return !(arePropsEqual && isStateEqual)
	}

	editFolder = folder => {
		const {
			openModal,
			folderChain
		} = this.props

		openModal('edit', 'folder', { folder, folderChain })
	}

	deleteFolder = folder => {
		const {
			openModal,
			folderChain
		} = this.props

		openModal('delete', 'folder', { folder, folderChain })
	}

	openProject = slug => {
		const {
			history,
			projectUrlSlug
		} = this.props

		history.push(projectUrlSlug + slug)
	}

	editProject = (project, duplicate) => {
		this.props.openModal('edit', 'project', {
			...project,
			duplicate
		})
	}

	deleteProject = project => {
		this.props.openModal('delete', 'project', { data: project })
	}

	componentDidMount = _ => {
		setTimeout(_ => {
			this.setState({
				hasMounted: true
			})
		}, 1)
	}

	handleDragOverProject = e => {

	}

	getSubtitle = (type, folders, projects) => {
		let returnString = ''

		if (folders.length) {
			returnString += `${folders.length} folder${folders.length > 1 ? 's' : ''}`
		}

		if (projects.length) {
			if (folders.length) {
				returnString += ', '
			}

			returnString += `${projects.length} project${projects.length > 1 ? 's' : ''}`
		}

		return returnString
	}

	render() {
		const {
			folderObject,
			folderChain,
			allFolders,
			hasSearch,
			allProjects,
			searchTerm,
			compact,
			upFolderCallback,
			selectCallback,
			currentlyDraggedElement,
			isShowingArchived,
			isSidebarShowingFavourites,
			favouriteProjects,
			isLast,
			setDraggedProviderRef
		} = this.props

		let childFolders = []
		let visibilityFilteredProjects = []
		let visibilityFilteredFolders = []

		if (!hasSearch) {
			folderObject.folders.forEach(folderId => {
				let tempClass = "folder"

				if (folderChain.includes(folderId)) {
					tempClass += ' active'
				}

				childFolders.push({
					folderObject: allFolders[folderId],
					tempClass: tempClass
				})
			})

			visibilityFilteredFolders = childFolders.filter(folder => {
				if (!folder.folderObject) {
					return false
				}

				return true
			})

			visibilityFilteredFolders.sort((a, b) => {
				let aName = a.folderObject.name.toLowerCase()
				let bName = b.folderObject.name.toLowerCase()

				if (aName < bName) return -1
				if (aName > bName) return 1
				return 0
			})

			folderObject.projects.forEach(projectId => {
				const projectObject = allProjects[projectId]

				projectObject && visibilityFilteredProjects.push(projectObject)
			})
		} else if (isSidebarShowingFavourites) {
			visibilityFilteredProjects = [...favouriteProjects]
		} else {
			each(allProjects, project => {
				if (!project.id || !project.name) {
					return
				}

				let shouldPush = !searchTerm || project.name.toLowerCase().includes(searchTerm.toLowerCase())

				if (!shouldPush) {
					return
				}

				shouldPush = (isShowingArchived && project.deleted_at) || (!isShowingArchived && !project.deleted_at)

				if (shouldPush) {
					visibilityFilteredProjects.push(project)
				}
			})
		}

		if (!isShowingArchived && !compact) {
			visibilityFilteredProjects = doSort(visibilityFilteredProjects, 'number', 'order')
		} else {
			visibilityFilteredProjects = doSort(visibilityFilteredProjects, 'alpha', 'name')
		}

		let projectsTitle = 'Projects'

		if (isShowingArchived) {
			projectsTitle = searchTerm ? 'Archived search results' : 'Archived projects'
		} else if (searchTerm) {
			projectsTitle = 'Search results'
		}

		return (
			<li className={`folder-contents ${this.state.hasMounted ? 'visible' : ''}`}>
				{visibilityFilteredFolders.length ?
					<span>
						Folders
					</span>
					: null
				}
				{compact && !folderObject.is_root &&
					(
						<button onClick={upFolderCallback} className='folder folder-up'>
							<Icon name='folder-open-o' />
							<div>
								<h2>
									{folderObject.name}
								</h2>
							</div>
						</button>
					)
				}
				{visibilityFilteredFolders.map((folder, i) => {
					let thisChildFolders = filter(allFolders, (filteredFolder) => {
						return filteredFolder.folder_id == folder.folderObject.id;
					})

					return (
						<div className="list-item" key={i}>
							<div className="folder-controls">
								<button className="tooltip-trigger" onClick={_ => this.editFolder(folder.folderObject)}>
									<Icon name="fe-edit-2" />
									<div className="tooltip">
										Edit folder
									</div>
								</button>
								<button className="tooltip-trigger" onClick={_ => { this.deleteFolder(folder.folderObject) }}>
									<Icon name="fe-trash-2" />
									<div className="tooltip">
										Delete folder
									</div>
								</button>
							</div>
							<Droppable
								droppableId={'folder-' + folder.folderObject.id}
								type="FOLDER"
								isDropDisabled={!isLast}
							>
								{provided => {
									return (
										<button
											ref={provided.innerRef}
											className={folder.tempClass + ' list-item clear'}
											key={folder.folderObject.id}
											onClick={_ => { selectCallback(folder.folderObject, folderChain) }}
										>
											<Icon name='folder' />
											<Icon name='folder-open' />
											<div>
												<h2>
													{folder.folderObject.name}
												</h2>
												{folder.folderObject.projects &&
													<span>
														{this.getSubtitle('folder', thisChildFolders, folder.folderObject.projects)}
													</span>
												}
											</div>
										</button>
									)
								}}
							</Droppable>
						</div>
					)
				})
				}
				<span>
					{projectsTitle}
				</span>
				<Droppable
					droppableId={hasSearch ? 'folder--null' : 'folder-contents-' + folderObject.id}
					isDropDisabled={!isLast}
					type={'FOLDER'}
				>
					{provided => (
						<div
							ref={provided.innerRef}
							className="projects-droppable"
						>
							{visibilityFilteredProjects.length ?
								visibilityFilteredProjects.map((project, i) => {
									let className = 'project clear list-item'

									if (currentlyDraggedElement == project.id) {
										className += ' dragged'
									}

									return (
										<Draggable
											isDragDisabled={!!(isMobile() || compact)}
											disableInteractiveElementBlocking={true}
											index={i}
											key={'project-' + project.id}
											draggableId={'project-' + project.id}
											type='PROJECT'
										>
											{provided => {
												if (provided.draggableProps.onTransitionEnd) {
													setDraggedProviderRef(provided)
												}

												return (
													<div ref={provided.innerRef}>
														<div className="list-item" {...provided.draggableProps} {...provided.dragHandleProps}>
															<div className="folder-controls">
																{!isShowingArchived ?
																	<button className="tooltip-trigger" onClick={_ => { this.editProject(project, true) }}>
																		<Icon name="copy" />
																		<div className="tooltip">
																			Duplicate project
																		</div>
																	</button>
																	: null}
																{!isShowingArchived ?
																	<button className="tooltip-trigger" onClick={_ => { this.editProject(project, false) }}>
																		<Icon name="fe-edit-2" />
																		<div className="tooltip">
																			Edit project
																		</div>
																	</button>
																	: null}
																<button className="tooltip-trigger" onClick={_ => { this.deleteProject(project) }}>
																	<Icon name="fe-trash-2" />
																	<div className="tooltip">
																		Delete project
																	</div>
																</button>
															</div>
															<NavLink
																to={this.props.projectUrlSlug + project.slug}
																className={className}
															>
																<Icon name='star' />
																<div>
																	<h2>
																		{project.name}
																	</h2>
																	{project.milestones ?
																		<span>
																			{project.milestones.length} milestone{project.milestones.length !== 1 ? 's' : ''}
																		</span>
																		: null
																	}
																</div>
															</NavLink>
														</div>
														{provided.placeholder}
													</div>
												)
											}}
										</Draggable>
									)
								})
								:
								!compact &&
								<button className="empty-alert">
									<Icon name="star-o" />
									<div>
										<h2>
											No projects
										</h2>
									</div>
								</button>
							}
							{provided.placeholder}
						</div>
					)}
				</Droppable>
			</li>
		)
	}
}

export default withRouter(connect(null, { openModal })(FolderContents))
